import { createContext } from 'react';
import { TCredentialsType, IUpdateCredentials } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface IInitialFormData {
	credentialType: Nullable<TCredentialsType>;
	credentialName: string;
	apiKey: string;
	apiSecret: string;
}

export interface IEditCredentialsState {
	needRefetchData: boolean;
	initialFormData: Nullable<IInitialFormData>;
	credentialID: string;
	credentialType: Nullable<TCredentialsType>;
	credentialName: string;
	apiKey: string;
	apiSecret: string;
	dataForSubmit: Nullable<IUpdateCredentials>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editCredentialsInitialState: IEditCredentialsState = {
	needRefetchData: false,
	initialFormData: null,
	credentialID: '',
	credentialType: null,
	credentialName: '',
	apiKey: '',
	apiSecret: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditCredentialsContext extends IEditCredentialsState {
	refetchData(value: boolean): void;
	changeCredentialName(value: string): void;
	changeApiKey(value: string): void;
	changeApiSecret(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setDataForSubmit(value: Nullable<IUpdateCredentials>): void;
	resetFields(): void;
}

export const EditCredentialsContext = createContext<IEditCredentialsContext>({
	refetchData: () => undefined,
	changeCredentialName: () => undefined,
	changeApiKey: () => undefined,
	changeApiSecret: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editCredentialsInitialState,
});
